import Stars from "components/BookReview/Stars";
import BookHighlights from "components/BookRow/BookHighlights";
import LocalizedDate from "components/shared/LocalizedDate";
import ReadingFormatIcon from "components/shared/ReadingFormatIcon";
import { UserBookAvatar } from "components/userBook/UserBookAvatars";
import Text from "hardcover-ui/components/Text";
import { BookSerializersBookByline, UserBookSerializersUserBookByline, UserBookSerializersUserBookDate } from "types/serializers";
import { slugIdConstants } from "types/UserBookStatusType";

export default function UserBookHighlights({
  book,
  userBook,
  userBookRead,
  hideHighlights = false,
  dateAdded = true
}: {
  book: BookSerializersBookByline;
  userBook: UserBookSerializersUserBookByline;
  userBookRead?: UserBookSerializersUserBookDate
  hideHighlights?: boolean;
  dateAdded?: boolean;
}) {
  const showUserHighlights = userBook.rating > 0 || userBookRead?.finishedAt || userBook.lastReadDate || (dateAdded && userBook.dateAdded);
  const isFinished = userBookRead?.finishedAt || userBook.statusId === slugIdConstants.read;

  if(!showUserHighlights) {
    if(hideHighlights) {
      return false;
    } else {
      return <BookHighlights book={book} />
    }
  }

  return (
    <div>
      <div className="mt-2 flex flex-row items-center space-x-1">
        <UserBookAvatar userBook={userBook} book={book} showRating={false} />
        <div className="flex flex-col space-y-1">
          { isFinished ? (
            <>
              { userBookRead?.finishedAt ? (
                <span>
                  { userBookRead?.edition?.readingFormatId && (
                    <Text variant="secondary" size="sm" className="pl-1">
                      <ReadingFormatIcon readingFormatId={userBookRead.edition?.readingFormatId} size="sm" />
                    </Text>
                  )}
                  <Text variant="secondary" size="sm" className="pl-1">
                    Finished on <LocalizedDate date={String(userBookRead.finishedAt)} />
                  </Text>
                </span>
              ) : (
                <>
                  {userBook.lastReadDate ? (
                    <Text variant="secondary" size="sm" className="pl-1">
                      Last finished on <LocalizedDate date={String(userBook.lastReadDate)} />
                    </Text>
                  ) : (
                    <Text variant="secondary" size="sm" className="pl-1">
                      Added on <LocalizedDate date={String(userBook.dateAdded)} />
                    </Text>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              <Text as="div" variant="secondary" size="sm">
                Added on <LocalizedDate date={String(userBook.dateAdded)} />
              </Text>
            </>
          )}

          { userBook.rating > 0 && (
            <Stars rating={userBook.rating} size={6} />
          )}
        </div>
      </div>
      {!hideHighlights && !isFinished && <BookHighlights book={book} />}
    </div>
  );
}
